import { Accordion, Col, Container, Row } from "react-bootstrap"; 
const AcknowledgementAccordion= ({sampleRequestDetails})=>{
return(
 
<Accordion.Item eventKey="4">
    <Accordion.Header><b>Acknowledgement</b></Accordion.Header>
    <Accordion.Body>
        <p className="text-danger">
             <i>  
            Researcher should be prepared to transport sample using labeled, covered secondary containment</i>  
        </p>
        <p>
        <i>  *I verify that I have read and understood both the Clinical Protocol NOCOMPOUNDNAP1001- Amendment 10 “Generation of reagents from human-derived biological samples for the development and control of laboratory assays and procedures” and the latest version of TV-SOP-11772 “Request and Use of Bodily Fluids and Tissue Samples From Employee Volunteer Donors”.
            </i> </p>
        <p className="mt-2">
        <i>   *I acknowledge that the sample(s) I am receiving have not been tested for infectious diseases.</i>
        </p>
        <p className="mt-2">
            Initial:<b> {sampleRequestDetails?.request?.acknoledgement_initials || '-'}</b>
        </p>
    </Accordion.Body>
</Accordion.Item>
 
);
}

export default AcknowledgementAccordion